import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'
import { gapY } from '@mobi/component-library/Utils/gap'

export const FormLayout = styled.div(
  {
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateRows: 'min-content 1fr min-content',
    minHeight: '100%',
    padding: '2.2rem 2rem 2rem',
    backgroundColor: colors.white,
    color: colors.black,
    fontFamily: font.family.primary,

    '> footer': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
  },
  gapY(spacing.bigx3)
)

export const DocumentBodyStyled = styled.div(
  { display: 'flex', flexDirection: 'column' },
  gapY(spacing.sm)
)
